
export enum actionTypes {
    //FetchVideoGroups
    FETCH_VIDEO_GROUPS_REQUEST = 'FETCH_VIDEO_GROUPS_REQUEST',
    FETCH_VIDEO_GROUPS_SUCCESS = 'FETCH_VIDEO_GROUPS_SUCCESS',
    FETCH_VIDEO_GROUPS_FAIL = 'FETCH_VIDEO_GROUPS_FAIL',
    //CreateVideoGroup
    CREATE_VIDEO_GROUP_SUCCESS = 'CREATE_VIDEO_GROUP_SUCCESS',
    CREATE_VIDEO_GROUP_FAIL = 'CREATE_VIDEO_GROUP_FAIL',
    //UpdateVideoGroup
    UPDATE_VIDEO_GROUP_SUCCESS = 'UPDATE_VIDEO_GROUP_SUCCESS',
    UPDATE_VIDEO_GROUP_FAIL = 'UPDATE_VIDEO_GROUP_FAIL',
    //DeleteVideoGroup
    DELETE_VIDEO_GROUP_SUCCESS = 'DELETE_VIDEO_GROUP_SUCCESS',
    DELETE_VIDEO_GROUP_FAILED = 'DELETE_VIDEO_GROUP_FAILED',
}

export interface GenericGroupStateProps {
    isLoading: boolean;
    status: stateStatusType | null;
    error: string | null;
}

export enum stateStatusType {
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED'
}

export interface GroupInput {
    name: string;
    description: string;
    group_order: number;
    imageFile?:File;
    image?:string
    icon?:string;
    button_name?: string
    eligibility?: string
}
export interface GroupError {
    name?: string;
    group_order?:string;
    description?: string;
    button_name?: string;
    eligibility?: string;
}

export interface VideoGroupProps {
    name: string;
    id: string;
    description:string;
    folder_id: string;
    image?: string;
    icon?: string
    group_order: number;
    button_name?:string;
    eligibility?:string
}
export interface FetchVideoGroupsRequestAction {
    type: actionTypes.FETCH_VIDEO_GROUPS_REQUEST;
}

export interface FetchVideoGroupsSuccessAction {
    type: actionTypes.FETCH_VIDEO_GROUPS_SUCCESS;
    payload: VideoGroupProps[];
}

export interface FetchVideoGroupsFailureAction {
    type: actionTypes.FETCH_VIDEO_GROUPS_FAIL;
    payload: string;
}
//CreateVideoGroup
export interface CreateVideoGroupSuccessAction {
    type: actionTypes.CREATE_VIDEO_GROUP_SUCCESS;
    payload: VideoGroupProps;
}
export interface CreateVideoGroupFailAction {
    type: actionTypes.CREATE_VIDEO_GROUP_FAIL;
    payload: string;
}

//UpdateVideoGroup
export interface UpdateVideoGroupSuccessAction {
    type: actionTypes.UPDATE_VIDEO_GROUP_SUCCESS;
    payload: VideoGroupProps;
}
export interface UpdateVideoGroupFailAction {
    type: actionTypes.UPDATE_VIDEO_GROUP_FAIL;
    payload: string;
}
//DeleteVideoGroup
export interface DeleteVideoGroupSuccessAction {
    type: actionTypes.DELETE_VIDEO_GROUP_SUCCESS;
    payload: string;
}
export interface DeleteVideoGroupFailureAction {
    type: actionTypes.DELETE_VIDEO_GROUP_FAILED;
    payload: string;
}


export type VideoGroupsActions =
    | FetchVideoGroupsRequestAction
    | FetchVideoGroupsSuccessAction
    | FetchVideoGroupsFailureAction
    | CreateVideoGroupSuccessAction
    | CreateVideoGroupFailAction
    | UpdateVideoGroupSuccessAction
    | UpdateVideoGroupFailAction
    | DeleteVideoGroupSuccessAction
    | DeleteVideoGroupFailureAction;
